<script>
    import { afterUpdate, onMount } from 'svelte';

    import LoadingAnim from "./loadingAnim.svelte"
    import { MasonryInfiniteGrid } from "@egjs/svelte-infinitegrid";
    import { ITEM_TYPE } from "@egjs/infinitegrid";
    let ig;
    export let location;
    export let navigate;

    import {
        urlCategories,
        urlAirplaneCategories,
        urlCountries,
        urlRegistrations,
        urlCapturePlaces,
        urlCaptureDates,
        urlDoubleSeater,
        urlSpecialPaint,
        urlFlares,
        urlAfterburner,
        urlLandingGear,
        urlBreakParachute,
        urlWaterPlane,
        urlStatic,
        urlCivil,
        urlMilitary,
        urlAirlineOperators,
        urlMuseum,
        urlCloseup,

    } from "./galleriesFilterStores";

    import Svelecte from 'svelecte';
    import { operationStore, query } from '@urql/svelte';

    import SlideshowModal from './slideshowModal.svelte';
    let showSlideshow = false;
    let slideshowImages = [];
    let currentSlideshowImageID = null;
    let currentSlideshowImage = {};

    let svelectes = {
        categories: {},
        airplaneCategories: {},
        countries: {},
        registrations: {},
        capturePlaces: {},
        captureDates: {},
        airlineOperators: {},
    };


    let availableFilters = emptyFilters(0);

    let categories = [];
    let allCategories = [];
    let svelectedCategories = [];

    let airplaneCategories = [];
    let allAirplaneCategories = [];
    let svelectedAirplanecategories = [];

    const getAirplaneCategories = operationStore(`
      query {
        categories: entries(section: "airplaneCategory", level:1) {
          id
          title
          children: children {
              id
          }
        }
        airplaneCategories: entries(section: "airplaneCategory", level:1) {
          id
          label: title
          options: children {
            id
            title
          }
        }
      }`,);
    query($getAirplaneCategories);
    $getAirplaneCategories.subscribe(query => {
        if(!query.fetching && query.error === undefined) {
            //console.log("categories arrived");
            allAirplaneCategories = query.data.airplaneCategories;
            allAirplaneCategories.forEach(airplaneCategory => {
                //https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/
                airplaneCategory.options.sort((a, b) => (a.title.localeCompare(b.title)));
            });
            allCategories = query.data.categories;
            categories = allCategories;
            airplaneCategories = allAirplaneCategories;
        }
    });

    let countries = [];
    let svelectedCountires = [];

    let capturePlaces = [];
    let svelectedCapturePlaces = [];

    let captureDates = [];
    let svelectedCaptureDates = [];

    let registrations = [];
    let svelectedRegistrations = [];

    let airlineOperators = [];
    let svelectedAirlineOperators = [];

    let setSvelecteFromUrlParams = emptySetSvelecteFromUrlParams();
    $: activeFilters = {
        categories: svelectedCategories,
        airplaneCategories: svelectedAirplanecategories,
        countries: svelectedCountires,
        registrations: svelectedRegistrations,
        capturePlaces: svelectedCapturePlaces,
        captureDates: svelectedCaptureDates,
        airlineOperators: svelectedAirlineOperators,
        doubleSeater:  $urlDoubleSeater ? $urlDoubleSeater : null,
        specialPaint: $urlSpecialPaint ? $urlSpecialPaint: null,
        flares: $urlFlares ? $urlFlares : null,
        afterburner: $urlAfterburner ? $urlAfterburner : null,
        landingGear: $urlLandingGear ? $urlLandingGear : null,
        breakParachute: $urlBreakParachute ? $urlBreakParachute : null,
        waterPlane: $urlWaterPlane ? $urlWaterPlane : null,
        static: $urlStatic ? $urlStatic : null,
        military: $urlMilitary ? $urlMilitary : null,
        civil: $urlCivil ? $urlCivil : null,
        museum: $urlMuseum ? $urlMuseum : null,
        closeup: $urlCloseup ? $urlCloseup : null,
    }
    function emptySetSvelecteFromUrlParams() {
        return {
            airplaneCategories: false,
            categories: false,
            countries: false,
            registrations: false,
            capturePlaces: false,
            captureDates: false,
            airlineOperators: false,
            once_everything: true,
        }
    }
    let categorySearchInput;
    let airplaneCategorySearchInput;
    let capturePlaceSearchInput;
    let captureDateSearchInput;
    let countrySearchInput;
    let registrationSearchInput;
    let airlineOperatorSearchInput;
    let currentSvelecteSearchValue = '';
    let currentFilteredSvelecteDropdownElements;
    onMount(() => {
        categorySearchInput = document.getElementById('categorySearchInput');
        trackSvelecteSearchInput(categorySearchInput, 'category');
        
        airplaneCategorySearchInput = document.getElementById('airplaneCategorySearchInput');
        trackSvelecteSearchInput(airplaneCategorySearchInput, 'airplaneCategory');
        
        capturePlaceSearchInput = document.getElementById('capturePlaceSearchInput');
        trackSvelecteSearchInput(capturePlaceSearchInput, 'capturePlace');
        
        captureDateSearchInput = document.getElementById('captureDateSearchInput');
        trackSvelecteSearchInput(captureDateSearchInput, 'captureDate');
        
        countrySearchInput = document.getElementById('countrySearchInput');
        trackSvelecteSearchInput(countrySearchInput, 'country');
        
        registrationSearchInput = document.getElementById('registrationSearchInput');
        trackSvelecteSearchInput(registrationSearchInput, 'registration');
        
        airlineOperatorSearchInput = document.getElementById('airlineOperatorSearchInput');
        trackSvelecteSearchInput(airlineOperatorSearchInput, 'airlineOperator');
    });
    function trackSvelecteSearchInput(inputRef, dorpdownClass) {
        inputRef.oninput = (e => {
            currentSvelecteSearchValue = inputRef.value;
            currentFilteredSvelecteDropdownElements = document.querySelectorAll('.'+dorpdownClass+' .sv-dropdown-content .sv-dd-item .sv-item');
        });
    }
    afterUpdate(() => {
        console.log("afterUpdate");
        if(setSvelecteFromUrlParams.once_everything && !arrayIsEmpty(images) && !arrayIsEmpty(allAirplaneCategories)) {
            if(!setSvelecteFromUrlParams.airplaneCategories) {
                setSvelecteFromUrlParams.airplaneCategories = updateSvelecteSelection(svelectes.airplaneCategories, $urlAirplaneCategories)
            }
            if(!setSvelecteFromUrlParams.categories) {
                setSvelecteFromUrlParams.categories = updateSvelecteSelection(svelectes.categories, $urlCategories)
            }
            if(!setSvelecteFromUrlParams.countries) {
                setSvelecteFromUrlParams.countries = updateSvelecteSelection(svelectes.countries, $urlCountries)
            }
            if(!setSvelecteFromUrlParams.registrations) {
                setSvelecteFromUrlParams.registrations = updateSvelecteSelection(svelectes.registrations, $urlRegistrations)
            }
            if(!setSvelecteFromUrlParams.capturePlaces) {
                setSvelecteFromUrlParams.capturePlaces = updateSvelecteSelection(svelectes.capturePlaces, $urlCapturePlaces)
            }
            if(!setSvelecteFromUrlParams.captureDates) {
                setSvelecteFromUrlParams.captureDates = updateSvelecteSelection(svelectes.captureDates, $urlCaptureDates)
            }
            if(!setSvelecteFromUrlParams.airlineOperators) {
                setSvelecteFromUrlParams.airlineOperators = updateSvelecteSelection(svelectes.airlineOperators, $urlAirlineOperators)
            }
            if(setSvelecteFromUrlParams.airplaneCategories && setSvelecteFromUrlParams.categories && setSvelecteFromUrlParams.countries && setSvelecteFromUrlParams.registrations && setSvelecteFromUrlParams.capturePlaces && setSvelecteFromUrlParams.captureDates && setSvelecteFromUrlParams.airlineOperators && setSvelecteFromUrlParams.once_everything) {
                svelectedAirplanecategories = svelectes.airplaneCategories.getSelection(true);
                svelectedCapturePlaces = svelectes.capturePlaces.getSelection(true);
                svelectedCaptureDates = svelectes.captureDates.getSelection(true);
                svelectedRegistrations = svelectes.registrations.getSelection(true);
                svelectedCountires = svelectes.countries.getSelection(true);
                svelectedCategories = svelectes.categories.getSelection(true);
                svelectedAirlineOperators = svelectes.airlineOperators.getSelection(true);
                activeFilters = {
                    categories: svelectedCategories,
                    airplaneCategories: svelectedAirplanecategories,
                    countries: svelectedCountires,
                    registrations: svelectedRegistrations,
                    capturePlaces: svelectedCapturePlaces,
                    captureDates: svelectedCaptureDates,
                    airlineOperators: svelectedAirlineOperators,
                    doubleSeater:  $urlDoubleSeater ? $urlDoubleSeater : null,
                    specialPaint: $urlSpecialPaint ? $urlSpecialPaint: null,
                    flares: $urlFlares ? $urlFlares : null,
                    afterburner: $urlAfterburner ? $urlAfterburner : null,
                    landingGear: $urlLandingGear ? $urlLandingGear : null,
                    breakParachute: $urlBreakParachute ? $urlBreakParachute : null,
                    waterPlane: $urlWaterPlane ? $urlWaterPlane : null,
                    static: $urlStatic ? $urlStatic : null,
                    military: $urlMilitary ? $urlMilitary : null,
                    civil: $urlCivil ? $urlCivil : null,
                    museum: $urlMuseum ? $urlMuseum : null,
                    closeup: $urlCloseup ? $urlCloseup : null,
                }
                updateImagesAndFilters();
                setSvelecteFromUrlParams.once_everything = false;
            }
        }

    });

    function updateSvelecteSelection(svelecteElement, selection) {
        if(selection.length > 0 && svelecteElement.getSelection() !== null && svelecteElement.getSelection().length === 0){
            svelecteElement.setSelection(selection, false);
            if(svelecteElement.getSelection() !== null && svelecteElement.getSelection().length > 0) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }


    function categoriesChanged() {
        $urlCategories = svelectedCategories;
        svelecteDropdownChanged(categorySearchInput);
    }
    
    function airplaneCategoriesChanged() {
        $urlAirplaneCategories = svelectedAirplanecategories;
        svelecteDropdownChanged(airplaneCategorySearchInput);
    }

    function countriesChanged() {
        $urlCountries = svelectedCountires;
        svelecteDropdownChanged(countrySearchInput);
    }

    function registrationsChanged() {
        $urlRegistrations = svelectedRegistrations;
        svelecteDropdownChanged(registrationSearchInput);
    }

    function capturePlacesChanged() {
        $urlCapturePlaces = svelectedCapturePlaces;
        svelecteDropdownChanged(capturePlaceSearchInput);
    }

    function captureDatesChanged() {
        $urlCaptureDates = svelectedCaptureDates;
        svelecteDropdownChanged(captureDateSearchInput);
    }

    function airlineOperatorsChanged() {
        $urlAirlineOperators = svelectedAirlineOperators;
        svelecteDropdownChanged(airlineOperatorSearchInput);
    }

    function svelecteDropdownChanged(inputRef) {        
        if(isCtrlPressed) {
            inputRef.value = currentSvelecteSearchValue;
            inputRef.dispatchEvent(new window.Event('input'));
        }
        updateImagesAndFilters();
    }

    let isCtrlPressed = false;
	function onKeyDown(e) {
        if(e.keyCode == 17) {
            isCtrlPressed = true;
        }
        if(e.keyCode == 13 && isCtrlPressed) {
            currentFilteredSvelecteDropdownElements.forEach((el) => {
                el.dispatchEvent(new window.Event('click'));
            });
            clearSearchAndCloseDropdowns();
        }
    }
	function onKeyUp(e) {
        if(e.keyCode == 17) {
            isCtrlPressed = false;
        }
    }
    function clearSearchAndCloseDropdowns() {
        categorySearchInput.value = '';
        categorySearchInput.dispatchEvent(new window.Event('input'));
        airplaneCategorySearchInput.value = '';
        airplaneCategorySearchInput.dispatchEvent(new window.Event('input'));
        capturePlaceSearchInput.value = '';
        capturePlaceSearchInput.dispatchEvent(new window.Event('input'));
        captureDateSearchInput.value = '';
        captureDateSearchInput.dispatchEvent(new window.Event('input'));
        countrySearchInput.value = '';
        countrySearchInput.dispatchEvent(new window.Event('input'));
        registrationSearchInput.value = '';
        registrationSearchInput.dispatchEvent(new window.Event('input'));
        airlineOperatorSearchInput.value = '';
        airlineOperatorSearchInput.dispatchEvent(new window.Event('input'));
        closeDropdowns();
    }
    function closeDropdowns(){
        let dropdowns = document.getElementsByClassName("sv-dropdown");
        for(let i = 0; i < dropdowns.length; i++){
            dropdowns[i].setAttribute('aria-expanded', 'false');
        }
        document.activeElement.blur();
    }
    function updateImagesAndFilters() {
        if(!isCtrlPressed) closeDropdowns();
        displayedImages = filterImages();
        updateAvailableFilters();
        items = getImagesInfinite(0, 10);
        window.dispatchEvent(new Event('resize'));
    }

    let images = [];
    let displayedImages = [];

    //GET ALL THE IMAGES
    /*
    const getAirplanes = operationStore(`{
      images: assets(
        volume: "airplanes"
      ) {
        id
        gridViewUrl: url @transform (handle: "grid", immediately: true)
        detailViewUrl: url @transform (handle: "detail", immediately: true)
        ... on airplanes_Asset {
          airplaneCategories: airplaneCategory {
            id
            title
            category: parent {
              id
              title
            }
          }
          countries: country {
            id
            title
          }
          registrations: registration {
            id
            title
          }
          capturePlace {
            id
            title
          }
          airlineOperators: airlineOperator {
            id
            title
          }
          captureDate @formatDateTime (format: "d.m.Y")
          specialPaint
          doubleSeater
          flares
          afterburner
          landingGear
          breakParachute
          waterPlane
          static
          military
        }
      }
    }
    `);

    query($getAirplanes)
    $getAirplanes.subscribe(query => {
        console.log(query)
        if(!query.fetching && query.error === undefined && query.data !== undefined) {
            if(arrayIsEmpty(images)) {
                console.log('images loaded')
                console.log(location)
                images = query.data.images;
                //shuffleArray(images);
                updateAvailableFilters();
            }
        }
        if(!query.fetching && query.error){
            //Reload the page
            window.location.reload();
        }
    });
    */
    let galleries_url = isProduction ? 'https://admin.jetnoise.ch/galleries' : 'https://admin.jetnoise.stumi/galleries';
    galleries_url = 'https://admin.jetnoise.ch/galleries';
    fetch(galleries_url/*, { mode: 'no-cors'}*/)
        .then(response=>response.json())
        .then(responsejson =>{
            //console.log("images arrived");
            if(arrayIsEmpty(images)) {
                images = responsejson.data.images;
                console.log(images);
                shuffleArray(images);
                updateAvailableFilters();
            }
            document.getElementById('anim-holder').style.display = 'none';
        })


    function updateAvailableFilters() {
        availableFilters = emptyFilters(0);
        displayedImages.forEach(image => {
            if(image.doubleSeater) availableFilters.doubleSeater++;
            if(image.specialPaint) availableFilters.specialPaint++;
            if(image.flares) availableFilters.flares++;
            if(image.afterburner) availableFilters.afterburner++;
            if(image.landingGear) availableFilters.landingGear++;
            if(image.breakParachute) availableFilters.breakParachute++;
            if(image.waterPlane) availableFilters.waterPlane++;
            if(image.static) availableFilters.static++;
            if(image.museum) availableFilters.museum++;
            if(image.closeup) availableFilters.closeup++;
            if(image.military === "1") availableFilters.military++;
            if(image.military === "0") availableFilters.civil++;
        })
        filterImages("categories").forEach(image => {
            image.airplaneCategories.forEach(airplaneCategory => {
                if(airplaneCategory.category !== null) {
                    availableFilters.categories.push(airplaneCategory.category.id);
                }
            });
        });
        filterImages("airplaneCategories").forEach(image => {
            image.airplaneCategories.forEach(airplaneCategory => {
                if(airplaneCategory !== null) availableFilters.airplaneCategories.push(airplaneCategory.id);
            });
            //availableFilters.airplaneCategories = availableFilters.airplaneCategories.concat(image.airplaneCategories);
        });
        filterImages("capturePlaces").forEach(image => {
            availableFilters.capturePlaces = availableFilters.capturePlaces.concat(image.capturePlace);
        });
        
        filterImages("captureDates").forEach(image => {   
            if(image.captureDate) {
                availableFilters.captureDates.push({id: image.captureDate.split("-").join(""), title: image.captureDate});
            }         
        });

        filterImages("countries").forEach(image => {
            availableFilters.countries = availableFilters.countries.concat(image.countries);
        });
        filterImages("registrations").forEach(image => {
            availableFilters.registrations = availableFilters.registrations.concat(image.registrations);
        });
        filterImages("airlineOperators").forEach(image => {
            availableFilters.airlineOperators = availableFilters.airlineOperators.concat(image.airlineOperators);
        });
        availableFilters.categories = [...new Set(availableFilters.categories)];
        availableFilters.airplaneCategories = [...new Set(availableFilters.airplaneCategories)];
        availableFilters.capturePlaces = arrayUniqueObjectsById(availableFilters.capturePlaces);
        availableFilters.captureDates = arrayUniqueObjectsById(availableFilters.captureDates);
        availableFilters.countries = arrayUniqueObjectsById(availableFilters.countries);
        availableFilters.registrations = arrayUniqueObjectsById(availableFilters.registrations);
        availableFilters.airlineOperators = arrayUniqueObjectsById(availableFilters.airlineOperators);

        categories = [];
        allCategories.forEach(category => {
            if(availableFilters.categories.includes(category.id)) categories.push(category);
        })
        airplaneCategories = [];
        if(arrayIsEmpty(svelectedCategories)) {
            allAirplaneCategories.forEach(category => {
                let availableOptions = [];
                category.options.forEach(airplaneCategory => {
                    if(availableFilters.airplaneCategories.includes(airplaneCategory.id)) availableOptions.push(airplaneCategory);
                })
                if(!arrayIsEmpty(availableOptions)) {
                    let categoryAvailableOptions = {
                        id: category.id,
                        label: category.label,
                        options: availableOptions
                    }
                    airplaneCategories.push(categoryAvailableOptions)
                }
            })
        } else {
            allAirplaneCategories.forEach(category => {
                    if(svelectedCategories.includes(category.id))airplaneCategories.push(category)
            })
        }

        capturePlaces = availableFilters.capturePlaces.sort((a, b) => (a.title.localeCompare(b.title)));
        captureDates = availableFilters.captureDates.sort((a, b) => (b.title.localeCompare(a.title)))
        countries = availableFilters.countries.sort((a, b) => (a.title.localeCompare(b.title)));
        registrations = availableFilters.registrations.sort((a, b) => (a.title.localeCompare(b.title)));
        airlineOperators = availableFilters.airlineOperators.sort((a, b) => (a.title.localeCompare(b.title)));
    }

    function emptyFilters(booleanEmpty) { // booleanEmpty is 0 or null
        return {
            categories: [],
            airplaneCategories: [],
            countries: [],
            registrations: [],
            capturePlaces: [],
            captureDates: [],
            airlineOperators: [],
            doubleSeater: booleanEmpty,
            specialPaint: booleanEmpty,
            flares: booleanEmpty,
            afterburner: booleanEmpty,
            landingGear: booleanEmpty,
            breakParachute: booleanEmpty,
            waterPlane: booleanEmpty,
            static: booleanEmpty,
            military: booleanEmpty,
            civil: booleanEmpty,
            museum: booleanEmpty,
            closeup: booleanEmpty,
        }
    }

    function onImageClick() {
        slideshowImages = displayedImages;
        currentSlideshowImageID = this.dataset.id;
        currentSlideshowImage = slideshowImages.find( ({ id }) => id === currentSlideshowImageID );
        showSlideshow = true;
    }

    function filterImages(ignore = "") {
        let filteredImages = [];

        if(activeFilters === undefined) {
            activeFilters = emptyFilters(null);
        }
        images.forEach(image => {
            
                console.log(captureDates.find(o => ( o.title == image.captureDate))?.id);
            
            if(
                image.gridViewUrl !== null &&
                (arrayIsEmpty(activeFilters.categories) || (!arrayIsEmpty(image.airplaneCategories) && (image.airplaneCategories.find(o => {if(o.category !== null) return activeFilters.categories.includes(o.category.id)}))) || ignore === 'categories') &&
                (arrayIsEmpty(activeFilters.airplaneCategories) || (!arrayIsEmpty(image.airplaneCategories) && (image.airplaneCategories.find(o => activeFilters.airplaneCategories.includes(o.id)))) || ignore === 'airplaneCategories') &&
                (arrayIsEmpty(activeFilters.capturePlaces) || (!arrayIsEmpty(image.capturePlace) && (activeFilters.capturePlaces.includes(image.capturePlace[0].id)) || ignore === 'capturePlaces')) &&
                (arrayIsEmpty(activeFilters.captureDates) || (image.captureDate && activeFilters.captureDates.includes(captureDates.find(o => ( o.title == image.captureDate))?.id) || ignore === 'captureDates')) &&
                (arrayIsEmpty(activeFilters.countries) || (!arrayIsEmpty(image.countries) && (image.countries.find(o => activeFilters.countries.includes(o.id)))) || ignore === 'countries') &&
                (arrayIsEmpty(activeFilters.registrations) || (!arrayIsEmpty(image.registrations) &&(image.registrations.find(o => activeFilters.registrations.includes(o.id)))) || ignore === 'registrations') &&
                (arrayIsEmpty(activeFilters.airlineOperators) || (!arrayIsEmpty(image.airlineOperators) &&(image.airlineOperators.find(o => activeFilters.airlineOperators.includes(o.id)))) || ignore === 'airlineOperators') &&
                (activeFilters.doubleSeater === null || (activeFilters.doubleSeater === image.doubleSeater) || ignore === "doubleSeater") &&
                (activeFilters.specialPaint === null || (activeFilters.specialPaint === image.specialPaint) || ignore === "specialPaint") &&
                (activeFilters.flares === null || (activeFilters.flares === image.flares) || ignore === "flares") &&
                (activeFilters.afterburner === null || (activeFilters.afterburner === image.afterburner) || ignore === "afterburner") &&
                (activeFilters.landingGear === null || (activeFilters.landingGear === image.landingGear) || ignore === "landingGear") &&
                (activeFilters.breakParachute === null || (activeFilters.breakParachute === image.breakParachute) || ignore === "breakParachute") &&
                (activeFilters.waterPlane === null || (activeFilters.waterPlane === image.waterPlane) || ignore === "waterPlane") &&
                (activeFilters.static === null || (activeFilters.static === image.static) || ignore === "static") &&
                (activeFilters.museum === null || (activeFilters.museum === image.museum) || ignore === "museum") &&
                (activeFilters.closeup === null || (activeFilters.closeup === image.closeup) || ignore === "closeup") &&
                (activeFilters.military === null || (activeFilters.military && image.military === "1") || ignore === "military") &&
                (activeFilters.civil === null || (activeFilters.civil && image.military === "0") || ignore === "civil")
            ){
                filteredImages.push(image);
            }
        });
        return filteredImages;
    }
    let items = [];
    function getImagesInfinite(nextGroupKey, count) {
        const nextImages = [];
        for (let i = 0; i < count; ++i) {
            const nextKey = nextGroupKey * count + i;
            if(nextKey < displayedImages.length){
                nextImages.push({ groupKey: nextGroupKey, key: nextKey, image: displayedImages[nextKey] });
            }
        }
        return nextImages;
    }

    //Helper functions
    function arrayIsEmpty(array) {
        //If it's not an array
        if (!Array.isArray(array)) {
            return false;
        }
        //If it is an array, check its length property
        return (array.length === 0);
    }
    function arrayUniqueObjectsById(a) {
        let seen = new Set();
        return a.filter(item => {
            let k = item.id;
            return seen.has(k) ? false : seen.add(k);
        });
    }
    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
</script>
<main class="content galleries">
    <h1>Galleries</h1>
    <div class="filter filter-grid">
        <div class="item">
            <Svelecte class="svelecte-control category" options={categories} inputId="categorySearchInput" disabled={(availableFilters.categories.length === 0)}  placeholder="Kategorie auswählen" multiple={true} clearable={true} bind:value={svelectedCategories} on:change={categoriesChanged} bind:this={svelectes.categories}/>
            <Svelecte class="svelecte-control airplaneCategory" options={airplaneCategories} inputId="airplaneCategorySearchInput" disabled={(availableFilters.airplaneCategories.length === 0)} placeholder="Flugzeugtyp / Formation auswählen" multiple={true} clearable={true} bind:value={svelectedAirplanecategories} on:change={airplaneCategoriesChanged} bind:this={svelectes.airplaneCategories}/>
            <Svelecte class="svelecte-control capturePlace" options={capturePlaces} inputId="capturePlaceSearchInput" disabled={(availableFilters.capturePlaces.length === 0)} placeholder="Aufnahmeort auswählen" multiple={true} clearable={true} bind:value={svelectedCapturePlaces} on:change={capturePlacesChanged} bind:this={svelectes.capturePlaces}/>
            <Svelecte class="svelecte-control captureDate" options={captureDates} inputId="captureDateSearchInput" disabled={(availableFilters.captureDates.length === 0)} placeholder="Aufnahmedatum auswählen" multiple={true} clearable={true} bind:value={svelectedCaptureDates} on:change={captureDatesChanged} bind:this={svelectes.captureDates}/>
        </div>
        <div class="item">
            <Svelecte class="svelecte-control country" options={countries} inputId="countrySearchInput" disabled={(availableFilters.countries.length === 0)} placeholder="Land auswählen" multiple={true} clearable={true} bind:value={svelectedCountires} on:change={countriesChanged} bind:this={svelectes.countries}/>
            <Svelecte class="svelecte-control registration" options={registrations} inputId="registrationSearchInput" disabled={(availableFilters.registrations.length === 0)} placeholder="Immatrikulation auswählen" multiple={true} clearable={true} bind:value={svelectedRegistrations} on:change={registrationsChanged} bind:this={svelectes.registrations}/>
            <Svelecte class="svelecte-control airlineOperator" options={airlineOperators} inputId="airlineOperatorSearchInput" disabled={(availableFilters.airlineOperators.length === 0)} placeholder="Airline / Operator auswählen" multiple={true} clearable={true} bind:value={svelectedAirlineOperators} on:change={airlineOperatorsChanged} bind:this={svelectes.airlineOperators}/>
        </div>
        <div class="item">
            <input type="checkbox" disabled={(availableFilters.doubleSeater === 0)} bind:checked={$urlDoubleSeater} id="doubleSeater" on:change={updateImagesAndFilters}>
            <label for="doubleSeater">
                Doppelsitzer
            </label>
            <input type="checkbox" disabled={(availableFilters.specialPaint === 0)} bind:checked={$urlSpecialPaint} id="specialPaint" on:change={updateImagesAndFilters}>
            <label for="specialPaint">
                Spezialbemalung
            </label>
            <input type="checkbox" disabled={(availableFilters.flares === 0)} bind:checked={$urlFlares} id="flares" on:change={updateImagesAndFilters}>
            <label for="flares">
                Flares
            </label>
            <input type="checkbox" disabled={(availableFilters.afterburner === 0)} bind:checked={$urlAfterburner} id="afterburner" on:change={updateImagesAndFilters}>
            <label for="afterburner">
                Nachbrenner
            </label>
            <input type="checkbox" disabled={(availableFilters.landingGear === 0)} bind:checked={$urlLandingGear} id="landinggear" on:change={updateImagesAndFilters}>
            <label for="landinggear">
                Fahrwerk
            </label>
            <input type="checkbox" disabled={(availableFilters.breakParachute === 0)} bind:checked={$urlBreakParachute} id="breakparachute" on:change={updateImagesAndFilters}>
            <label for="breakparachute">
                Bremsschirm
            </label>
            <input type="checkbox" disabled={(availableFilters.waterPlane === 0)} bind:checked={$urlWaterPlane} id="waterPlane" on:change={updateImagesAndFilters}>
            <label for="waterPlane">
                Wasserflugzeug
            </label>
            <input type="checkbox" disabled={(availableFilters.static === 0)} bind:checked={$urlStatic} id="static" on:change={updateImagesAndFilters}>
            <label for="static">
                Statisch
            </label>
            <input type="checkbox" disabled={(availableFilters.military === 0)} bind:checked={$urlMilitary} id="military" on:change={updateImagesAndFilters}>
            <label for="military">
                Militär
            </label>
            <input type="checkbox" disabled={(availableFilters.civil === 0)} bind:checked={$urlCivil} id="civil" on:change={updateImagesAndFilters}>
            <label for="civil">
                Zivil
            </label>
            <input type="checkbox" disabled={(availableFilters.museum === 0)} bind:checked={$urlMuseum} id="museum" on:change={updateImagesAndFilters}>
            <label for="museum">
                Museum
            </label>
            <input type="checkbox" disabled={(availableFilters.closeup === 0)} bind:checked={$urlCloseup} id="closeup" on:change={updateImagesAndFilters}>
            <label for="closeup">
                Closeup
            </label>
        </div>
    </div>

    <LoadingAnim/>
    <MasonryInfiniteGrid
            bind:this={ig}
            class="masonry-grid"
            gap={35}
            items = {items}
            usePlaceholder={true}
            on:requestAppend={({ detail: e }) => {
                e.nextGroupKey = (+e.groupKey || 0) + 1;
                items = [
                    ...items,
                    ...getImagesInfinite(e.nextGroupKey, 10)
                ];
                //WAIT and READY functions and tests
                /*e.wait();
                setTimeout(()=>{
                    e.ready();
                     items = [
                    ...items,
                    ...getImagesInfinite(e.nextGroupKey, 10)
                    ];
                    //TODO:
                    //Check if this is Temporary but well working Workaround?
                    //window.dispatchEvent(new Event('resize'));
                }, 100);
                */
              }}
            let:visibleItems
    >
        {#each visibleItems as item (item.key)}
            {#if item.type === ITEM_TYPE.NORMAL}
                {#if item.data.image !== undefined && item.data.image.gridViewUrl !== null}
                <div class="item">
                    <img src="{item.data.image.gridViewUrl}" data-grid-maintained-target="true" data-id="{item.data.image.id}" on:click={onImageClick}>
                </div>
                {/if}
            {:else if item.type === ITEM_TYPE.VIRTUAL}
                <div class="placeholder">
                    Placeholder
                </div>
            {/if}
        {/each}
    </MasonryInfiniteGrid>
    <SlideshowModal bind:open={showSlideshow} bind:currentSlideshowImageID={currentSlideshowImageID} bind:slideshowImages={slideshowImages} bind:currentSlideshowImage={currentSlideshowImage}/>
</main>
<svelte:window on:keydown={onKeyDown} on:keyup={onKeyUp} />
<style lang="scss">
  .filter {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    max-width: 1420px;
    margin-bottom: 1em;
    input {
      display: none;
    }
  }
  /*
  .item {
    width: calc(25% - 23px);
    width: calc(33% - 20px);
    max-width: 449px;
    img {
      width: 100%;
      display: block;
      cursor: pointer;
      box-shadow: var(--box-shadow);
    }
  }

   */
  input:disabled + label {
    color: var(--disabled-grey);
    cursor: not-allowed;
  }
  input:checked + label {
    color: var(--jetnoise-orange);
    border-color: var(--jetnoise-orange);
  }
  label {
    cursor: pointer;
    display: inline-block;
    margin: 0 .5rem .7rem 0;
    padding: .6rem .7rem;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

</style>